import { guid } from "@buildwithflux/shared";
// like design these urls paths with love
// assume users will see them in the UI (because they do!)
export var bucketSubFolders;
(function (bucketSubFolders) {
    bucketSubFolders["documentAssets"] = "document_assets";
    bucketSubFolders["documentChatAttachments"] = "project/chat/attachments";
    bucketSubFolders["userAvatars"] = "user_avatars";
    bucketSubFolders["organizationAvatars"] = "organization_avatars";
})(bucketSubFolders || (bucketSubFolders = {}));
const UID_PATTERN = /(-[a-zA-Z0-9]+){5}(\.[a-zA-Z0-9]+)$/;
const EXTENSION_PATTERN = /\.[a-zA-Z0-9-_]+$/;
export function sanitizeFileName(name) {
    return name.replace(/[/\\?&$@=;+,{}()^`'”\]\[~#% *:|"<>]/g, "-");
}
export function addUidToFileName(name) {
    const uid = guid();
    return sanitizeFileName(name).replace(EXTENSION_PATTERN, (match) => `-${uid}${match}`);
}
export function createUserAvatarFilename(name) {
    return `${bucketSubFolders.userAvatars}/${addUidToFileName(name)}`;
}
export function createDocumentAssetFilename(name) {
    return `${bucketSubFolders.documentAssets}/${addUidToFileName(name)}`;
}
export function createDocumentChatAttachmentFilename(name) {
    return `${bucketSubFolders.documentChatAttachments}/${addUidToFileName(name)}`;
}
/**
 * Each doc should have one preview. Prefix by owner for easy deletion.
 *
 * QUESTION: Why do we need to use `currentChangeId` here?
 */
export function createDocumentGerberPreviewFilename(uid, owner_uid, currentChangeId) {
    return `${bucketSubFolders.documentAssets}/${owner_uid}/${uid}/${currentChangeId}`;
}
export function removeUidFromKey(key) {
    return key.replace(UID_PATTERN, (_match, _g1, extension) => extension);
}
//# sourceMappingURL=naming.js.map